import React, { useEffect, useState } from 'react'
import { getRegionUrl } from '@/helpers/getCountryCode'

interface LearnMoreProps {
  text: string
  version?: string
}

const LearnMore = (props: LearnMoreProps) => {
  const [html, setHtml] = useState(props.text)

  useEffect(() => {
    const region = localStorage.getItem('region') || 'US'
    const privacyPolicyRoute = getRegionUrl(region, 'privacy-policy')
    const termsRoute = getRegionUrl(region, 'terms-of-use')

    const updated = props.text
      .replace(/\/privacy-policy/g, privacyPolicyRoute)
      .replace(/\/terms-of-use/g, termsRoute)

    setHtml(updated)
  }, [props.text])

  return props?.version ? (
    <section className="max-w-[375px] mx-auto pb-8">
      <p
        className="text-center text-S dark:text-[#6E6E70] text-[#C3C3C4] [&>a]:text-inherit [&>a]:underline [&>a:visited]:text-inherit [&>a:visited]:underline"
        dangerouslySetInnerHTML={{ __html: html }}
      ></p>
    </section>
  ) : (
    <section className="max-w-[375px] mx-auto px-4 pb-10">
      <p
        className="text-center text-S text-textSecondary [&>a]:text-inherit [&>a]:underline [&>a:visited]:text-inherit [&>a:visited]:underline"
        dangerouslySetInnerHTML={{ __html: html }}
      ></p>
    </section>
  )
}

export default LearnMore
